import * as React from 'react';
import { useObserver, observer } from 'mobx-react-lite';
import moment from 'moment-timezone';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import Icon from './Icon';
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-light-svg-icons';
import noResults from '../assets/images/NoDeskPhoto@2x.png';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
	makeStyles,
	Backdrop,
	CircularProgress,
	Grid,
	Paper,
	Typography,
	Link,
	Dialog,
	DialogTitle,
	DialogContentText,
	DialogActions,
	DialogContent,
	TextField,
	Breadcrumbs,
} from '@material-ui/core';
import Slider from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Moment from 'react-moment';

import { stores } from '../store';

import List from '@material-ui/core/List';

import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles(theme => ({
	container: {
		padding: theme.spacing(0),
		height: 'calc(100vh - 98px)',
		margin: '0 !important',
	},
	headerMenuLinkActive: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		width: '70%',
		padding: '9px',
		fontWeight: 'bold',
		paddingTop: theme.spacing(0.5),
		borderBottom: `${theme.palette.primary.main} 4px solid !important`,
		color: theme.palette.text.primary,
		'&:hover': {
			backgroundColor: theme.palette.background.paper,
		},
	},
	MonthSelector: {
		marginLeft: '15px',
	},
	Autocompletenew: {
		'& .MuiInputLabel-root': {
			zIndex: 999,

			background: '#f9fbfd',
			marginLeft: '21px',
		},
		'& .MuiAutocomplete-inputRoot': {
			background: '#f9fbfd',
			width: '86% !important',
			marginLeft: '23px',
		},
		'& .MuiInputBase-input': {
			background: '#f9fbfd',
			width: '70px !important',
		},
		'& .MuiAutocomplete-clearIndicator': {
			display: 'none',
		},
		'& .MuiAutocomplete-input': {
			minWidth: '120% !important',
		},
		'& .MuiAutocomplete-inputRoot:hover': {
			backgroundColor: '#098BBD0A !important',
		},
		'& .MuiInputBase-input:hover': {
			backgroundColor: 'transparent !important',
		},
		'& .MuiIconButton-root:hover': {
			backgroundColor: '#098BBD0A !important',
		},
		'& .MuiAutocomplete-option[data-focus="true"]': {
			backgroundColor: '#098BBD0A !important',
		},
	},

	sldstyle: {
		width: '100%',
	},

	headerNav: {
		width: '100%',
		marginBottom: '4px',
		'& .MuiBreadcrumbs-ol': {},
		'& .MuiBreadcrumbs-separator': {
			display: 'none',
		},
		'& li.MuiBreadcrumbs-li': {
			margin: '-2px',
			width: '115px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			[theme.breakpoints.down('xs')]: {
				height: 36,
				width: 80,
			},
		},
		'& li.MuiBreadcrumbs-li a': {
			cursor: 'pointer',
			width: '100%',
			textAlign: 'center',
			padding: '16px',
			margin: '-2px',
		},
		'& li.MuiBreadcrumbs-li:hover': {
			backgroundColor: `${theme.palette.primary.main}0A`,
			cursor: 'pointer',

			textAlign: 'center',

			margin: '-2px',
		},
	},

	imageBlock: {
		width: '100%',
		height: '73%',
	},
	timebtn: {
		margin: '1px !important',
		minWidth: '0 !important',
		boxShadow: 'none !important',
		padding: '10px 4px !important',
		border: '1px solid rgba(9, 139, 189, 0.5)',
		marging: '1px !important',
		width: 'auto !important',
		color: '#098BBD',
		'&.MuiButton-root.Mui-disabled': {
			color: '#FFFFFF !important',
			border: '1px solid #CFDBE5 !important',
			backgroundColor: '#CFDBE5 !important',
		},
	},
	timebtnnew: {
		margin: '1px !important',
		minWidth: '0 !important',
		boxShadow: 'none !important',
		padding: '10px 4px !important',
		border: '1px solid rgba(9, 139, 189, 0.5)',
		marging: '1px !important',
		width: 'auto !important',
		color: '#FFFFFF',
		'&.MuiButton-root.Mui-disabled': {
			color: '#FFFFFF !important',
			border: '1px solid #CFDBE5 !important',
			backgroundColor: '#CFDBE5 !important',
		},
	},
	paper: {
		display: 'flex',
		height: '267px',
		overflow: 'hidden',
		flexDirection: 'column',
		textAlign: 'left',
		'& .MuiInputBase-input': {
			background: 'none',
		},
	},
	fileUploadIcon: {
		width: '40px',
		height: '40px',
		borderRadius: '50%',
		position: 'relative',
		cursor: 'pointer',
		backgroundColor: theme.palette.primary.main,
		'& > *': {
			position: 'absolute',
			top: '12px',
			left: '14px',
			color: theme.palette.background.paper,
		},
	},
	fileUploadInput: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		borderBottom: `${theme.palette.grey[100]} 1px solid`,
		margin: theme.spacing(3, 0),
	},
	fileUploadInputError: {
		borderBottom: `${theme.palette.error.main} 1px solid`,
		color: theme.palette.error.main,
	},
	createCancelLink: {
		'& > *': {
			cursor: 'pointer',
			margin: theme.spacing(0, 0, 0, 2),
		},
	},
	disableLink: {
		color: theme.palette.grey[100],
		cursor: 'default',
	},
	accessDimensions: {
		width: '50%',
		height: '40%',
		margin: 'auto',
		display: 'block',
		objectFit: 'contain',
	},
	textMargin: {
		textAlign: 'center',
	},

	alignStyle: {
		padding: '0px 0px !important',
	},
	feedBadge: {
		'& span': {
			backgroundColor: '#357a38',
			padding: 'inherit',
			fontSize: '0.7rem',
			marginRight: '32px',
			transform: 'scale(1) translate(100%, -60%)',
		},
	},
	dateSlider: {
		width: '724px',
		/* Extra small devices (phones, 600px and down) */
		'@media only screen and (max-width: 600px)': {
			width: '222px',
		},
		/* Small devices (portrait tablets and large phones, 600px and up) */
		'@media only screen and (min-width: 600px)': {
			width: '272px',
		},
		/* Medium devices (landscape tablets, 768px and up) */
		'@media only screen and (min-width: 768px)': {
			width: '372px',
		},

		/* Large devices (laptops/desktops, 992px and up) */
		'@media only screen and (min-width: 992px)': {
			width: '456px',
		},

		/* Extra large devices (large laptops and desktops, 1200px and up) */
		'@media only screen and (min-width: 1200px)': {
			width: '573px',
		},
		'@media only screen and (min-width: 1300px)': {
			width: '674px',
		},
		'@media only screen and (min-width: 1350px)': {
			width: '724px',
		},
		'@media only screen and (min-width: 1500px)': {
			width: '824px',
		},
		'@media only screen and (min-width: 1650px)': {
			width: '922px',
		},
		'@media only screen and (min-width: 1800px)': {
			width: '1024px',
		},
	},
	timeSlider: {
		width: '724px',
		/* Extra small devices (phones, 600px and down) */
		'@media only screen and (max-width: 600px)': {
			width: '222px',
		},
		/* Small devices (portrait tablets and large phones, 600px and up) */
		'@media only screen and (min-width: 600px)': {
			width: '272px',
		},
		/* Medium devices (landscape tablets, 768px and up) */
		'@media only screen and (min-width: 768px)': {
			width: '372px',
		},

		/* Large devices (laptops/desktops, 992px and up) */
		'@media only screen and (min-width: 992px)': {
			width: '456px',
		},

		/* Extra large devices (large laptops and desktops, 1200px and up) */
		'@media only screen and (min-width: 1200px)': {
			width: '573px',
		},
		'@media only screen and (min-width: 1300px)': {
			width: '674px',
		},
		'@media only screen and (min-width: 1350px)': {
			width: '724px',
		},
		'@media only screen and (min-width: 1500px)': {
			width: '824px',
		},
		'@media only screen and (min-width: 1650px)': {
			width: '922px',
		},
		'@media only screen and (min-width: 1800px)': {
			width: '1024px',
		},
	},
	testnew: {
		'& .slick-prev, .slick-next': {
			height: '35px',
			width: '37px',
			background: 'grey',
		},
		'& .slick-slide, .slick-active': {
			width: 'auto',
			maxWidth: '50px',
		},
		'.slick-prev:before, .slick-next:before': {
			color: 'black !important',
		},
		'& .slick-list': {
			margin: '0 12px',
		},
		'& .slick-track': {
			marginLeft: '0 !important',
		},
	},
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff',
	},
	disableButton: {
		'&.MuiButton-contained.Mui-disabled': {
			color: '#FFFFFF',
			border: '1px solid #CFDBE5',
			backgroundColor: '#CFDBE5',
		},
	},
	arrowLeft: {
		width: '40px',
		left: '-20px',
		lineHeight: '0',
		position: 'absolute',
		top: '50%',
		padding: '0',
		transform: 'translateY(-50%)',
		cursor: 'pointer',
		border: 'none',
		'&:hover': {
			backgroundColor: `${theme.palette.primary.main}0A`,
			width: 40,
			borderRadius: '50%',
			height: 40,
			left: '-37px',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		},
	},
	arrowRight: {
		width: '40',
		right: '-26px',
		lineHeight: '0',
		position: 'absolute',
		top: '50%',
		padding: '0',
		transform: 'translateY(-50%)',
		cursor: 'pointer',
		border: 'none',
		'&:hover': {
			backgroundColor: `${theme.palette.primary.main}0A`,
			width: 40,
			borderRadius: '50%',
			right: '-42px',
			height: 40,
			lineHeight: '0',
			position: 'absolute',
			transform: 'translateY(-50%)',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
		},
	},
}));

const DeskInfo = observer(() => {
	const classes = useStyles();
	const ArrowLeft = (props: any) => <Icon {...props} className={classes.arrowLeft} icon={faChevronLeft} size="3rem" />;
	const ArrowRight = (props: any) => (
		<Icon {...props} className={classes.arrowRight} icon={faChevronRight} size="3rem" />
	);
	const settingsForTime = {
		arrows: true,
		infinite: false,
		draggable: true,
		swipeToSlide: true,
		slidesToShow: 14,
		slidesToScroll: 1,
		dots: false,
		speed: 100,
		initialSlide: 0,
		prevArrow: <ArrowLeft />,
		nextArrow: <ArrowRight />,
		responsive: [
			{
				breakpoint: 599,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 5,
				},
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 7,
				},
			},
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 9,
				},
			},
			{
				breakpoint: 1299,
				settings: {
					slidesToShow: 11,
				},
			},
			{
				breakpoint: 1349,
				settings: {
					slidesToShow: 13,
				},
			},
			{
				breakpoint: 1499,
				settings: {
					slidesToShow: 14,
				},
			},
			{
				breakpoint: 1649,
				settings: {
					slidesToShow: 16,
				},
			},
			{
				breakpoint: 1799,
				settings: {
					slidesToShow: 18,
				},
			},
			{
				breakpoint: 2199,
				settings: {
					slidesToShow: 20,
				},
			},
		],
	};
	const settingsForDate = {
		arrows: true,
		infinite: false,
		draggable: true,
		swipeToSlide: true,
		slidesToShow: 14,
		slidesToScroll: 1,
		dots: false,
		speed: 100,
		initialSlide: 0,
		prevArrow: <ArrowLeft />,
		nextArrow: <ArrowRight />,
		responsive: [
			{
				breakpoint: 599,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 5,
				},
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 7,
				},
			},
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 9,
				},
			},
			{
				breakpoint: 1299,
				settings: {
					slidesToShow: 11,
				},
			},
			{
				breakpoint: 1349,
				settings: {
					slidesToShow: 13,
				},
			},
			{
				breakpoint: 1499,
				settings: {
					slidesToShow: 14,
				},
			},
			{
				breakpoint: 1649,
				settings: {
					slidesToShow: 16,
				},
			},
			{
				breakpoint: 1799,
				settings: {
					slidesToShow: 18,
				},
			},
			{
				breakpoint: 2199,
				settings: {
					slidesToShow: 20,
				},
			},
		],
	};

	const { route } = React.useContext(stores.context.routes);

	const routes = React.useContext(stores.context.routes);

	const spaces = React.useContext(stores.context.spaces);

	const user = React.useContext(stores.context.user);

	const daysCount: number = spaces.Availabledays.AllowBookingsBeforeXDays
		? spaces.Availabledays.AllowBookingsBeforeXDays
		: 62;
	let monthsList: any = [];

	let dateStart = moment(moment().format('L'));
	let dateEnd = moment(
		moment()
			.add(daysCount, 'days')
			.format('L'),
	);

	while (dateEnd > dateStart || dateStart.format('M') === dateEnd.format('M')) {
		monthsList.push(dateStart.format('MMMM YYYY'));
		dateStart.add(1, 'month');
	}

	const [BookingId, setBookingId] = React.useState<any>('');
	const [bookingLoader, setBookingLoader] = React.useState(true);
	const [zoneSingleRecord, setZoneSingleRecord] = React.useState<any>();

	const [esmeDialogOpen, setEsmeDialogOpen] = React.useState(false);

	const [bookingavailable, setbookingavailable] = React.useState(false);
	const [initialTimerange, setInitialTimeRange]: any = React.useState(null);
	const [consecutiveTimeDialog, setConsecutiveTimeDialog] = React.useState(false);
	const [FloorDescription, setFloorDescription] = React.useState<any>();

	const startTimeSlot = '00:00';
	const endTimeSlot = '23:45';
	const interval = 15;

	const [selectedDate, setSelectedDate] = React.useState({ id: 0, date: moment().format('YYYY-MM-DD') });
	const [newDataVariablemonth1, setnewDataVariablemonth] = React.useState<any>(
		moment(moment(selectedDate.date).format('YYYY/MM/DD')).format('MMMM'),
	);
	const [selectedMonth, setselectedmonthval] = React.useState<any>(moment().format('MM'));
	const [selectedYear, setselectedYear] = React.useState<any>(moment().format('YYYY'));
	const [crnttttmnth, setcurntmnth] = React.useState<any>(0);

	const [noofdayscount, setnoofdays] = React.useState<any>(31);

	const [officeHoursdnmc, setofficeHoursdnmc] = React.useState<any>([]);

	const [buildingentities, setbuidlingentities] = React.useState<any>([]);

	const [buildingId, setBuildingId] = React.useState<any>(null);
	const [officeHoursData, setOfficeHoursData] = React.useState<any>([]);

	const [keyval, setkeyval] = React.useState<any>(0);

	const [dateSlots, setDateSlots] = React.useState<any>([]);
	let updatedDate = moment().format('YYYY-MM-DD');
	React.useEffect(() => {
		updatedDate = selectedDate.date;
		const buildingData = buildingentities.filter((buildingInfo: any) =>
			buildingInfo.Entity_Id === route.params.zoneId ? buildingInfo : null,
		);
		let buildingNumber: any = '';

		if (buildingData.length > 0) {
			buildingNumber = buildingData[0].BuildingId;
			setBuildingId(buildingNumber);

			let hoursData = officeHoursdnmc.filter((officeHoursData: any) =>
				officeHoursData.buildingId === buildingNumber ? officeHoursData : null,
			);

			const apiCount: number = spaces.Availabledays.AllowBookingsBeforeXDays
				? spaces.Availabledays.AllowBookingsBeforeXDays
				: 62;

			let daysDiff = moment(hoursData[hoursData.length - 1].startDate, 'YYYY-MM-DD').diff(moment(), 'days');

			let endDay = hoursData[hoursData.length - 1].startDate;

			let remainingDays = apiCount - daysDiff;

			for (let i = 1; i <= remainingDays; i++) {
				let obj = {
					startDate: `${moment(endDay)
						.add(i, 'days')
						.format('YYYY-MM-DD')}T00:00:00`,
					endDate: `${moment(endDay)
						.add(i, 'days')
						.format('YYYY-MM-DD')}T00:00:00`,
					dayVisible: false,
					webOnly: false,
					startTime: '00:00:00',
					endTime: '24:00:00',
					buildingId: `${buildingNumber}`,
				};
				hoursData.push(obj);
			}

			for (let i = 0; i < daysDiff; i++) {
				let obj = {
					startDate: `${moment()
						.add(i, 'days')
						.format('YYYY-MM-DD')}T00:00:00`,
					endDate: `${moment()
						.add(i, 'days')
						.format('YYYY-MM-DD')}T00:00:00`,
					dayVisible: false,
					webOnly: false,
					startTime: '00:00:00',
					endTime: '24:00:00',
					buildingId: `${buildingNumber}`,
				};

				const foundItem = hoursData.find((item: any) => {
					return moment(item.startDate, 'YYYY-MM-DD').isSame(moment(obj.startDate, 'YYYY-MM-DD'));
				});
				if (foundItem === undefined) {
					hoursData.splice(i, 0, obj);
				}
			}

			setOfficeHoursData(hoursData);

			const monthlyDays =
				hoursData &&
				hoursData.slice(0).filter((dateValues: any) => {
					let month = new Date(dateValues.startDate).toLocaleString('default', { month: 'long' });
					let year = new Date(dateValues.startDate).getFullYear();
					let newupdatedmonth = moment(selectedDate.date).format('MMMM');
					let newupdatedyear = moment(selectedDate.date).format('YYYY');
					return month === newupdatedmonth && year === Number(newupdatedyear) ? dateValues : null;
				});

			let jsonObject = monthlyDays.map((e: any) => JSON.stringify(e));
			let uniqueSet = new Set(jsonObject);
			let uniqueArray = Array.from(uniqueSet).map((e: any) => JSON.parse(e));

			setDateSlots(uniqueArray);
		}
	}, [noofdayscount, selectedDate]);

	React.useEffect(() => {
		setcurntmnth(crnttttmnth);
		getSlots(0);
	}, [crnttttmnth]);

	React.useEffect(() => {
		const dynmhours = async () => {
			const hrs = await spaces.dynamichours(user.currentSiteId);
			const search = new URLSearchParams(window.location.search);
			if (hrs !== '' && !search.get('startTime') && !search.get('endTime')) {
				getSlots(0);
			}
			setbuidlingentities(hrs.buildings_entities);
			setofficeHoursdnmc(hrs.officeHours);
		};

		if (user.currentSiteId) {
			spaces.fetchCondecoDetails(user.currentSiteId);
		}
		const flrdataindividual = user.flrdataname.filter((item: any) => item.floorId == route.params.floorId);

		if (flrdataindividual.length > 0) {
			setFloorDescription(flrdataindividual && flrdataindividual[0].floorName);
		}
		spaces.roomdatesavailability(route.params.zoneId);
		dynmhours();
	}, [user.currentSiteId, user.permissions, user.flrdataname]);
	React.useEffect(() => {
		if (user.currentSiteId !== '' && spaces.condecoDetails) {
			if (spaces.condecoDetails && spaces.condecoDetails.ISEMSAvailable) {
				setBookingLoader(false);
			} else {
				setBookingLoader(true);
				window.location.href = `/spaces/spacesHome/NA/NA`;
			}

			let currentmnthonly: any = moment().format('MM');

			const searchnew = new URLSearchParams(window.location.search);
			let diffnew: number = moment(searchnew.get('startTime'), 'YYYY-MM-DD').diff(
				moment().format('YYYY-MM-DD'),
				'days',
			);
			let yeamtnday = moment()
				.add(diffnew, 'days')
				.format('MM');
			if (searchnew.get('startTime') && currentmnthonly !== yeamtnday) {
				let diff: number = moment(searchnew.get('startTime'), 'YYYY-MM-DD').diff(moment().format('YYYY-MM-DD'), 'days');
				let yearandmonth = moment()
					.add(diff, 'days')
					.format('YYYY-MM');
				let Noofdayscount2: any = moment(yearandmonth, 'YYYY-MM').daysInMonth();
				setselectedmonthval(yeamtnday);
				setnoofdays(Noofdayscount2);
			} else if (currentmnthonly == yeamtnday) {
				setcurntmnth(1);
				let a = moment().endOf('month');
				let b = moment();

				setnoofdays(a.diff(b, 'days') + 1);
				setselectedmonthval(moment().format('MM'));
			} else {
				let a = moment().endOf('month');
				let b = moment();

				setnoofdays(a.diff(b, 'days') + 1);
				setselectedmonthval(moment().format('MM'));
			}
		}
	}, [spaces.condecoDetails, user.currentSiteId, user.floorsingledata]);

	React.useEffect(() => {
		const fetchZoneData = () => {
			const test = user.currentSiteId ? user.currentSiteId : '';
			spaces
				.fetchZoneDetails(test, route.params.floorId)
				.then((res: any) => {
					const Zonelist = res.Zones;
					const ZoneData = Zonelist.findIndex((Zonerecord: any) => {
						return Zonerecord.ZoneId === route.params.zoneId;
					});
					setZoneSingleRecord(Zonelist[ZoneData]);
				})
				.catch(() => {
					setBookingLoader(false);
				});
		};

		fetchZoneData();
	}, [user.currentSiteId]);
	React.useEffect(() => {
		const search = new URLSearchParams(window.location.search);
		if (search.get('startTime') && search.get('endTime') && buildingentities != '') {
			let currentmnthnew: any = moment().format('MM');
			let searchyear: any = moment(search.get('startTime')).format('YYYY');
			let searchmnth: any = moment(search.get('startTime')).format('MM');
			let searchday: any = moment(search.get('startTime')).format('DD');
			setnewDataVariablemonth(
				moment(moment(searchyear + '-' + searchmnth + '-' + searchday).format('YYYY/MM/DD')).format('MMMM'),
			);
			setkeyval(keyval + 1);

			let diff: number =
				currentmnthnew == searchmnth
					? moment(search.get('startTime'), 'YYYY-MM-DD').diff(moment().format('YYYY-MM-DD'), 'days')
					: moment(search.get('startTime'), 'YYYY-MM-DD').diff(
							moment().format(searchyear + '-' + searchmnth + '-' + '01'),
							'days',
					  );

			if (diff < 0) {
				diff = 0;
			}
			const startTime: any = moment(search.get('startTime')).format('HH:mm');
			const endTime: any = moment(search.get('endTime'))
				.subtract(15, 'minutes')
				.format('HH:mm');

			const newDate =
				currentmnthnew == searchmnth
					? {
							id: 0 + diff,
							date: moment()
								.add(diff, 'days')
								.format('YYYY-MM-DD'),
					  }
					: {
							id: 0 + diff,
							date: moment()
								.add(diff, 'days')
								.format(searchyear + '-' + searchmnth + '-' + searchday),
					  };

			updatedDate = newDate.date;
			setSelectedDate(newDate);

			if (getSlots(0 + diff)) {
				let startIndex = getSlots(0 + diff).findIndex((item: any) => item == startTime);
				let endIndex = getSlots(0 + diff).findIndex((item: any) => item == endTime);
				if (startIndex >= 0 && endIndex >= 0) {
					setInitialTimeRange({ start: 'time_' + startIndex, end: 'time_' + endIndex });
				}
			}
		} else if (search.get('startTime') && search.get('endTime')) {
			let currentmnthnew: any = moment().format('MM');
			let searchyear: any = moment(search.get('startTime')).format('YYYY');
			let searchmnth: any = moment(search.get('startTime')).format('MM');
			let searchday: any = moment(search.get('startTime')).format('DD');
			setnewDataVariablemonth(
				moment(moment(searchyear + '-' + searchmnth + '-' + searchday).format('YYYY/MM/DD')).format('MMMM'),
			);
			setkeyval(keyval + 1);

			let diff: number =
				currentmnthnew == searchmnth
					? moment(search.get('startTime'), 'YYYY-MM-DD').diff(moment().format('YYYY-MM-DD'), 'days')
					: moment(search.get('startTime'), 'YYYY-MM-DD').diff(
							moment().format(searchyear + '-' + searchmnth + '-' + '01'),
							'days',
					  );

			if (diff < 0) {
				diff = 0;
			}
			const startTime: any = moment(search.get('startTime')).format('HH:mm');
			const endTime: any = moment(search.get('endTime'))
				.subtract(15, 'minutes')
				.format('HH:mm');

			const newDate =
				currentmnthnew == searchmnth
					? {
							id: 0 + diff,
							date: moment()
								.add(diff, 'days')
								.format('YYYY-MM-DD'),
					  }
					: {
							id: 0 + diff,
							date: moment()
								.add(diff, 'days')
								.format(searchyear + '-' + searchmnth + '-' + searchday),
					  };

			updatedDate = newDate.date;
			setSelectedDate(newDate);

			if (getSlots(0 + diff)) {
				let startIndex = getSlots(0 + diff).findIndex((item: any) => item == startTime);
				let endIndex = getSlots(0 + diff).findIndex((item: any) => item == endTime);

				if (startIndex >= 0 && endIndex >= 0) {
					setInitialTimeRange({ start: 'time_' + startIndex, end: 'time_' + endIndex });
				}
			}
		} else {
			getSlots(0);
			setSelectedDate({
				id: 0,
				date: moment().format('YYYY-MM-DD'),
			});
		}
	}, [zoneSingleRecord, buildingentities]);
	const handleAvailableclose = () => {
		setbookingavailable(false);
	};

	const handleConsecutiveSlots = () => {
		setConsecutiveTimeDialog(false);
	};

	const [open, setOpen] = React.useState(false);

	const handleClose = () => {
		setOpen(false);
	};

	const redirection = () => {
		window.location.href = `/myBookings`;
	};

	const [openFinal, setDialogFinal] = React.useState(false);

	const handleClickFinalOpen = () => {
		setOpen(false);
		setEsmeDialogOpen(false);
		Roombookingfinal();
	};
	const handleClickfinal = () => {
		setDialogFinal(false);
		setSelectedTimeRange(null);
		clearHighlight();
	};

	const [selectedDateforpop, setSelectedDateforpopup] = React.useState({ id: 0, date: moment().format('DD/MM/YYYY') });
	const [selectedTimeRange, setSelectedTimeRange]: any = React.useState(null);
	const [timeSlots, setTimeSlots] = React.useState([]);
	const [bookDeskbuttonText, setBookDeskbuttonText] = React.useState('');

	const [currentAvailableTime, setCurrentAvailableTime]: any = React.useState(null);
	const [bookedRange, setBookedRange]: any = React.useState([]);
	const slideRefForDateSlider = React.useRef<Slider>(null);
	const slideRefForConstantDateSlider = React.useRef<Slider>(null);
	const slideRefForTimeSlider = React.useRef<Slider>(null);

	React.useEffect(() => {
		const search = new URLSearchParams(window.location.search);
		let startTime = search.get('startTime');
		let scrollToDateSlot: number = 0;
		let scrollToTimeSlot: number = 0;

		dateSlots &&
			dateSlots.forEach((dateSlot: any, index: number) => {
				if (getParsedDate(dateSlot.startDate) == selectedDate.date) {
					scrollToDateSlot = index;
					return;
				}
			});

		timeSlots &&
			startTime &&
			timeSlots.forEach((slot: any, index: number) => {
				if (slot == getParsedTime(startTime)) {
					scrollToTimeSlot = index;
					return;
				}
			});
		slideRefForDateSlider?.current?.slickGoTo(scrollToDateSlot);
		slideRefForConstantDateSlider?.current?.slickGoTo(selectedDate.id);
		slideRefForTimeSlider?.current?.slickGoTo(scrollToTimeSlot);
	}, [dateSlots, timeSlots, selectedDate]);

	const getParsedDate = (date: any) => {
		let d = new Date(date);
		return [d.getFullYear(), ('0' + (d.getMonth() + 1)).slice(-2), ('0' + d.getDate()).slice(-2)].join('-');
	};
	const getParsedTime = (time: any) => {
		let t = new Date(time);
		return ('0' + t.getHours()).slice(-2) + ':' + ('0' + t.getMinutes()).slice(-2);
	};

	React.useEffect(() => {
		const starnewDateTime = `${selectedDate.date}T00:00:00Z`;
		const endnewDateTime = `${selectedDate.date}T23:45:00Z`;
		if (zoneSingleRecord) {
			getBookingData(zoneSingleRecord && zoneSingleRecord.RoomId, starnewDateTime, endnewDateTime);
		}
	}, [selectedDate, zoneSingleRecord, BookingId]);

	const monthChangeEventHandler = (event: object, value: any) => {
		let values = value.split(' ');
		let selectedMonth: string = values[0];
		let selectedYear: number = Number(values[1]);
		setselectedYear(selectedYear);
		_handleDays(0);
		getSlots(0);
		let currentmnth: any = moment().format('MM');

		let monthnumber = moment()
			.month(selectedMonth)
			.format('MM');
		let dateArray: any = moment()
			.add(daysCount, 'days')
			.format('YYYY-MMMM-DD')
			.split('-');
		let Noofdayscount: any = 0;
		let LastDayOfMonth = moment()
			.add(daysCount, 'days')
			.format('YYYY-MM-DD');

		if (dateArray[0] === selectedYear.toString() && dateArray[1] === selectedMonth) {
			let eventdate = moment(LastDayOfMonth);
			let todaysdate = moment(LastDayOfMonth).format('YYYY-MM-01');
			Noofdayscount = eventdate.diff(todaysdate, 'days') + 1;
		} else {
			Noofdayscount = moment(selectedYear + '-' + monthnumber, 'YYYY-MM').daysInMonth();
		}

		setselectedmonthval(monthnumber);
		getSlots(0);
		if (currentmnth == monthnumber) {
			setcurntmnth(1);
			let a = moment().endOf('month');
			let b = moment();
			setnoofdays(a.diff(b, 'days') + 1);
		} else {
			setcurntmnth(0);
			setnoofdays(Noofdayscount);
		}
		let dateoldformat =
			currentmnth == monthnumber
				? { id: 0, date: moment().format('YYYY-MM-DD') }
				: { id: 0, date: selectedYear + '-' + monthnumber + '-' + '01' };
		updatedDate = dateoldformat.date;
		getSlots(0);
		setSelectedDate(dateoldformat);
	};

	const _handleDays = (id: number) => {
		settingsForTime['initialSlide'] = 0;
		slideRefForTimeSlider?.current?.slickGoTo(0);
		setCurrentAvailableTime(null);
		const selectDateValue =
			crnttttmnth == 1
				? {
						id,
						date: moment()
							.add(id, 'days')
							.format('YYYY-MM-DD'),
				  }
				: {
						id,
						date: moment(selectedYear + '-' + selectedMonth + '-' + '01')
							.add(id, 'days')
							.format('YYYY-MM-DD'),
				  };
		updatedDate = selectDateValue.date;
		setSelectedDate(selectDateValue);

		setSelectedDateforpopup(
			crnttttmnth == 1
				? {
						id,
						date: moment()
							.add(id, 'days')
							.format('YYYY-MM-DD'),
				  }
				: {
						id,
						date: moment(selectedYear + '-' + selectedMonth + '-' + '01')
							.add(id, 'days')
							.format('YYYY-MM-DD'),
				  },
		);
		setSelectedTimeRange(null);
		clearHighlight();
		getSlots(id);
	};
	React.useEffect(() => {
		getAvailableStatus();
		if (initialTimerange) {
			setBookingLoader(true);
			setTimeout(() => {
				_highlightTimeRange(initialTimerange.start, initialTimerange.end);
				setTimeout(() => setBookingLoader(false), 1000);
			}, 2000);
		}
	}, [bookedRange]);
	const getBookingData = (roomId: any, starDateTime: string, endDateTime: string) => {
		setBookingLoader(true);
		spaces.getDeskBookedDateTime(roomId, starDateTime, endDateTime).then((res: any) => {
			let bookedData = res.map((item: any) => ({
				start: moment(item.eventStartTime)
					.tz('Europe/London')
					.format('HH:mm'),
				end: moment(item.eventEndTime)
					.tz('Europe/London')
					.format('HH:mm'),
			}));
			setBookedRange(bookedData);
			if (!initialTimerange) {
				setBookingLoader(false);
			}
		});
	};

	const getRoundedDate = (minutes: any = 15, d = moment().tz('Europe/London')) => {
		var time = 1000 * 60 * minutes;
		var date = new Date(d.format('YYYY-MM-DDTHH:mm'));
		var rounded = new Date(date.getTime() + time - (date.getTime() % time));
		return rounded;
	};

	const getSlots = (id: number) => {
		let slots: Array<any> | any = [];
		let startTime = moment(startTimeSlot, 'HH:mm');
		if (id == 0 && crnttttmnth == 1) {
			if (
				moment()
					.tz('Europe/London')
					.format('HH:mm') < moment(startTimeSlot, 'HH:mm').format('HH:mm')
			) {
				startTime = moment(startTimeSlot, 'HH:mm');
			} else {
				startTime = moment(getRoundedDate());
			}
		}
		var endTime = moment(endTimeSlot, 'HH:mm');
		if (startTime.isAfter(endTime)) {
			setTimeSlots(slots);
			return;
		}

		const buildingData = buildingentities.filter((buildingInfo: any) =>
			buildingInfo.Entity_Id === route.params.zoneId ? buildingInfo : null,
		);

		let buildingNumber: any = buildingData.length > 0 ? buildingData[0].BuildingId : null;
		let hoursData = officeHoursdnmc.filter((officeHoursData: any) =>
			officeHoursData.buildingId === buildingNumber ? officeHoursData : null,
		);
		console.log(hoursData);

		const choosenDate =
			officeHoursData &&
			officeHoursData
				.slice(0)
				.filter((item: any) =>
					moment(item.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD') === updatedDate ? item : null,
				);
		if (choosenDate.length > 0 && choosenDate[0].dayVisible) {
			setTimeSlots([]);
			setBookDeskbuttonText('');
			setSelectedTimeRange(null);
		} else {
			while (startTime <= endTime) {
				if (buildingNumber !== null && choosenDate.length > 0) {
					if (
						moment(choosenDate[0].startTime, 'HH:mm') <= startTime &&
						moment(choosenDate[0].endTime, 'HH:mm').subtract('15', 'minutes') >= startTime
					) {
						slots.push(moment(startTime).format('HH:mm'));
						startTime.add(interval, 'minutes');
					} else {
						startTime.add(interval, 'minutes');
					}
				} else {
					slots.push(moment(startTime).format('HH:mm'));
					startTime.add(interval, 'minutes');
				}
			}
			setTimeSlots(slots);
		}
		return slots;
	};
	const _highlightTimeRange = (start: string, end: string) => {
		let temp: any = { start, end };
		clearHighlight();
		let cursor1 = temp.start;
		let cursor2 = temp.end;
		if (Number(cursor1.split('_')[1]) < Number(cursor2.split('_')[1])) {
			let obj = { start: cursor1, end: cursor2 };
			setSelectedTimeRange(obj);
			highlightButtons(cursor1.split('_')[1], cursor2.split('_')[1], '#098BBD');
		} else {
			let obj = { start: cursor2, end: cursor1 };
			setSelectedTimeRange(obj);
			highlightButtons(cursor2.split('_')[1], cursor1.split('_')[1], '#098BBD');
		}
		setInitialTimeRange(null);
		setTimeout(() => setBookingLoader(false), 1000);
	};
	const _handleTimeRange = (id: string) => {
		if (!selectedTimeRange) {
			if (document.getElementById(id)) {
				document.getElementById(id)!.style.backgroundColor = '#098BBD';
				document.getElementById(id)!.style.color = '#fff';
				setSelectedTimeRange(() => ({ start: id }));
			}
		} else if (selectedTimeRange['start'] == id) {
			clearHighlight();
			setSelectedTimeRange(null);
			return;
		} else {
			let temp: any = { ...selectedTimeRange };
			clearHighlight();
			if (temp.start && temp.end) {
				let current = Number(id.split('_')[1]);
				if (Number(temp.start.split('_')[1]) > current) {
					temp.start = id;
				} else if (Number(temp.start.split('_')[1]) < current) {
					temp.end = id;
				}
			}
			let cursor1 = temp.start ? temp.start : selectedTimeRange.start;
			let cursor2 = temp.end ? temp.end : id;
			if (selectedTimeRange['end'] == id) {
				cursor2 = 'time_' + (Number(selectedTimeRange.end.split('_')[1]) - 1);
			}
			if (Number(cursor1.split('_')[1]) < Number(cursor2.split('_')[1])) {
				let obj = { start: cursor1, end: cursor2 };
				setSelectedTimeRange(obj);
				highlightButtons(cursor1.split('_')[1], cursor2.split('_')[1], '#098BBD');
			} else {
				let obj = { start: cursor2, end: cursor1 };
				setSelectedTimeRange(obj);
				highlightButtons(cursor2.split('_')[1], cursor1.split('_')[1], '#098BBD');
			}
		}
	};

	const clearHighlight = () => {
		const butns: any = document.querySelectorAll('.timeBtnDefault');
		for (let butn of butns) {
			(butn as HTMLElement).style.backgroundColor = 'white';
			(butn as HTMLElement).style.color = '#098BBD';
		}
	};

	const highlightButtons = (start: any, end: any, color: any) => {
		const butns: any = document.querySelectorAll('.timeBtnDefault');
		let startFound = false;
		let endFound = false;
		for (let butn of butns) {
			if (butn.id.split('_')[1] == start) {
				startFound = true;
			}
			if (startFound && !endFound) {
				if ((butn as HTMLButtonElement).disabled) {
					setConsecutiveTimeDialog(true);
					setSelectedTimeRange(null);
					clearHighlight();
					break;
				}
				(butn as HTMLElement).style.backgroundColor = color;
				(butn as HTMLElement).style.color = 'white';
			}
			if (butn.id.split('_')[1] == end) {
				endFound = true;
				break;
			}
		}
	};

	const getAvailableStatus = () => {
		let available;
		let id = 0;
		for (let time of timeSlots) {
			let booked = checkSlotStatus('time_' + id);
			if (booked) {
				available = time;
				break;
			}
			id++;
		}
		if (timeSlots && timeSlots[0] == available) {
			setCurrentAvailableTime(null);
		} else if (available) {
			setCurrentAvailableTime(available);
		} else {
			setCurrentAvailableTime(timeSlots[timeSlots.length - 1]);
		}
	};

	const checkSlotStatus = (id: string) => {
		let booked = false;
		const index = Number(id.split('_')[1]);
		let slotTime = moment(timeSlots[index], 'HH:mm');
		bookedRange.forEach((booking: any) => {
			let currBookingStart = moment(booking.start, 'HH:mm');
			let currBookingEnd = moment(booking.end, 'HH:mm');
			if (slotTime.isBetween(currBookingStart, currBookingEnd.subtract(15, 'minutes'), undefined, '[]')) {
				booked = true;
			}
		});
		return booked;
	};
	const getSelectedTimeRange = () => {
		return {
			start:
				selectedTimeRange && selectedTimeRange.start && timeSlots[selectedTimeRange.start.split('_')[1]]
					? timeSlots[selectedTimeRange.start.split('_')[1]]
					: null,
			end:
				selectedTimeRange && selectedTimeRange.end && timeSlots[selectedTimeRange.end.split('_')[1]]
					? timeSlots[selectedTimeRange.end.split('_')[1]]
					: null,
		};
	};

	const cancelSlot = () => {
		setBookDeskbuttonText('');
		const floordata = user.floorsingledata;
		routes.navigate(
			{
				name: 'spacesHome',
				params: {
					clientId: floordata.clientId,
					floorId: floordata.floorId,
				},
			},
			{
				clearParams: true,
			},
		);
	};

	const [subjecttit, setSubject] = React.useState<any>('');

	const subject = (event: any) => {
		setSubject(event.target.value);
	};

	const [recordType, setRecordType] = React.useState<any>();
	const [setUpTypeId, setSetUpId] = React.useState<any>();
	const [poputmee, setPopuentimte] = React.useState<any>('');

	const floordata = user.floorsingledata;

	React.useEffect(() => {
		if (getSelectedTimeRange().end !== null || getSelectedTimeRange().start !== null) {
			const popupetime =
				getSelectedTimeRange().end == null
					? moment(getSelectedTimeRange().start, 'HH:mm')
							.add('15', 'minutes')
							.format('HH:mm')
					: moment(getSelectedTimeRange().end, 'HH:mm')
							.add('15', 'minutes')
							.format('HH:mm');
			setPopuentimte(popupetime);
		} else {
			setBookDeskbuttonText('');
		}
	}, [getSelectedTimeRange(), poputmee, selectedDateforpop]);
	React.useEffect(() => {
		if (poputmee === '' || getSelectedTimeRange().start === null) {
			setBookDeskbuttonText('');
		} else {
			setBookDeskbuttonText(
				`for ${moment(selectedDate.date).format('DD/MM/YYYY')} ${
					getSelectedTimeRange() && getSelectedTimeRange().start ? getSelectedTimeRange().start : ''
				} - ${poputmee}`,
			);
		}
	}, [bookDeskbuttonText, poputmee, getSelectedTimeRange().start]);

	const bookRoom = () => {
		setBookingLoader(true);
		const startDateTime = moment(selectedDate.date + 'T' + getSelectedTimeRange().start, 'YYYY-MM-DDTHH:mm')
			.utc()
			.add('01', 'hours')
			.format();
		const endDateTime =
			getSelectedTimeRange().end == null
				? moment(selectedDate.date + 'T' + getSelectedTimeRange().start, 'YYYY-MM-DDTHH:mm')
						.add('15', 'minutes')
						.utc()
						.add('01', 'hours')
						.format()
				: moment(selectedDate.date + 'T' + getSelectedTimeRange().end, 'YYYY-MM-DDTHH:mm')
						.add('15', 'minutes')
						.utc()
						.add('01', 'hours')
						.format();
		const popupetime =
			getSelectedTimeRange().end == null
				? moment(getSelectedTimeRange().start, 'HH:mm')
						.add('15', 'minutes')
						.format('HH:mm')
				: moment(getSelectedTimeRange().end, 'HH:mm')
						.add('15', 'minutes')
						.format('HH:mm');
		setPopuentimte(popupetime);

		spaces
			.DeskAvailable(zoneSingleRecord.RoomId, startDateTime, endDateTime)
			.then((res: any) => {
				const avairomm: any = res;
				setRecordType(avairomm[0].recordType);
				setSetUpId(avairomm[0].defaultSetupTypeId);

				if (avairomm[0].unavailableReason == 0) {
					setEsmeDialogOpen(true);
				} else {
					setbookingavailable(true);
				}
			})
			.finally(() => setBookingLoader(false));
	};
	const handleClickClose = () => {
		setEsmeDialogOpen(false);
		setSelectedTimeRange(null);
		clearHighlight();
	};

	const Roombookingfinal = () => {
		const startDateTime = moment(selectedDate.date + 'T' + getSelectedTimeRange().start, 'YYYY-MM-DDTHH:mm')
			.utcOffset(1)
			.format();
		const endDateTime =
			getSelectedTimeRange().end == null
				? moment(selectedDate.date + 'T' + getSelectedTimeRange().start, 'YYYY-MM-DDTHH:mm')
						.add('15', 'minutes')
						.utcOffset(1)
						.format()
				: moment(selectedDate.date + 'T' + getSelectedTimeRange().end, 'YYYY-MM-DDTHH:mm')
						.add('15', 'minutes')
						.utcOffset(1)
						.format();
		setBookingLoader(true);

		spaces
			.DeskBooking(zoneSingleRecord.RoomId, recordType, startDateTime, endDateTime, subjecttit, setUpTypeId)
			.then((res: any) => {
				setBookingId(res.BookingId);
				setDialogFinal(true);
			})
			.finally(() => setBookingLoader(false));
	};
	return useObserver(() => (
		<>
			<main className={classes.container}>
				<Backdrop className={classes.backdrop} open={bookingLoader}>
					<CircularProgress color="inherit" />
				</Backdrop>
				<Grid container direction="row" spacing={1}>
					<Grid item xs={12} md={7}>
						<Paper className={classes.paper}>
							<Grid style={{ minHeight: '265px', padding: '16px' }}>
								<Grid container item xs={12} justify="flex-start">
									<Typography variant="h5" paragraph={true}>
										{`${zoneSingleRecord && zoneSingleRecord.ZoneName}, ${zoneSingleRecord && FloorDescription}, ${
											floordata.buildingName
										}`}
									</Typography>
								</Grid>
								<ListItem>
									<Grid item xs={12} style={{ marginBottom: '-10px' }}>
										<ListItemText>
											<span style={{ fontWeight: 'bolder', fontSize: '0.90rem' }}>Provided features: </span>
											<List dense={true} style={{ display: 'inline-grid', left: '10px', top: '65%' }}></List>
										</ListItemText>
										<ListItemSecondaryAction style={{ left: '165px', marginTop: '6px' }}>
											<span
												style={{
													color: '#172A3F',
													letterSpacing: '0.01px',
													opacity: '1',
													font: 'normal normal normal 15px/19px Roboto',
												}}
											>
												None specified
											</span>
										</ListItemSecondaryAction>
										<ListItemSecondaryAction style={{}}></ListItemSecondaryAction>
									</Grid>
								</ListItem>

								<ListItem>
									<Grid item xs={12}>
										<ListItemText>
											<span style={{ fontWeight: 'bolder', fontSize: '0.90rem' }}>Available features:</span>{' '}
										</ListItemText>
										<ListItemSecondaryAction style={{ left: '165px' }}>
											<span
												style={{
													color: '#172A3F',
													letterSpacing: '0.01px',
													opacity: '1',
													font: 'normal normal normal 15px/19px Roboto',
												}}
											>
												None specified
											</span>
										</ListItemSecondaryAction>
									</Grid>
								</ListItem>
							</Grid>
						</Paper>
					</Grid>

					<Grid item xs={12} md={5}>
						<Paper className={classes.paper}>
							<Grid style={{ overflowY: 'hidden' }}>
								<Grid container item xs={12} justify="flex-start">
									<Breadcrumbs aria-label="breadcrumb" separator="" color="textSecondary" className={classes.headerNav}>
										<Link
											color="inherit"
											underline="none"
											style={{ cursor: 'pointer' }}
											className={classes.headerMenuLinkActive}
										>
											Photo
										</Link>
									</Breadcrumbs>
									<hr style={{ opacity: '.2', width: '100%', marginTop: '0px', marginBottom: '-2px' }} />
									{zoneSingleRecord && zoneSingleRecord.ZoneImageSource ? (
										<div>
											<img
												className={classes.imageBlock}
												src={require(`../assets/images/spaces/${zoneSingleRecord.ZoneImageSource}`)}
												alt="SitePhoto"
											/>
										</div>
									) : (
										<div style={{ height: '100%', margin: 'auto', padding: '45px' }}>
											<img src={noResults} className={classes.accessDimensions} alt="underconstruction" />

											<Typography variant="subtitle2" style={{ display: 'flex', justifyContent: 'center' }}>
												No desk photo available
											</Typography>
											<Typography
												color="textSecondary"
												variant="caption"
												style={{ display: 'flex', justifyContent: 'center' }}
											>
												Uploaded images will appear here
											</Typography>
										</div>
									)}
								</Grid>
							</Grid>
						</Paper>
					</Grid>
					{zoneSingleRecord && (
						<Grid item xs={12} md={12} lg={12}>
							<Paper className={classes.paper} style={{ padding: '15px' }}>
								<Grid container xs={12} md={12} lg={12} justify="flex-start">
									<Typography variant="h5" paragraph={true}>
										Bookable times &nbsp;
									</Typography>
								</Grid>
								<Grid container style={{ padding: '0px 30px', alignItems: 'center' }}>
									<Grid item md={9} lg={9}>
										{buildingId !== null && dateSlots.length > 0 ? (
											<Slider
												ref={slideRefForDateSlider}
												{...settingsForDate}
												className={classes.testnew + ' ' + classes.dateSlider}
											>
												{dateSlots.map((dateRange: any, id: any) => (
													<Button
														title={moment(new Date(dateRange.startDate))
															.format('DD/MM')
															.toString()}
														key={id}
														id={'days_' + id}
														onClick={() => _handleDays(id)}
														className={selectedDate.id == id ? classes.timebtnnew : classes.timebtn}
														color="primary"
														variant={selectedDate.id == id ? 'contained' : 'outlined'}
														disabled={dateRange.dayVisible}
													>
														{moment(new Date(dateRange.startDate))
															.format('DD/MM')
															.toString()}
													</Button>
												))}
											</Slider>
										) : (
											<Slider
												ref={slideRefForConstantDateSlider}
												{...settingsForDate}
												className={classes.testnew + ' ' + classes.dateSlider}
											>
												{Array(noofdayscount)
													.fill(0)
													.map((_, id) => (
														<Button
															title="date"
															key={id}
															id={'days_' + id}
															onClick={() => _handleDays(id)}
															className={selectedDate.id == id ? classes.timebtnnew : classes.timebtn}
															color="primary"
															variant={selectedDate.id == id ? 'contained' : 'outlined'}
														>
															<Moment format="DD/MM">
																{crnttttmnth == 1 ? moment().add(id, 'days') : moment(selectedMonth).add(id, 'days')}
															</Moment>
														</Button>
													))}
											</Slider>
										)}
									</Grid>
									<Grid item xs={12} md={3} lg={3}>
										<div key={keyval} className={classes.MonthSelector}>
											<Autocomplete
												options={monthsList}
												getOptionLabel={(option: any) => option}
												size="small"
												className={classes.Autocompletenew}
												ListboxProps={{ style: { overflow: 'hidden' } }}
												id="size-small-standard"
												noOptionsText="Loading..."
												autoComplete
												defaultValue={newDataVariablemonth1 + ' ' + selectedYear}
												onChange={(event: object, value: any) => monthChangeEventHandler(event, value)}
												renderInput={params => <TextField {...params} label="Month" variant="filled" margin="normal" />}
											/>
										</div>
									</Grid>
								</Grid>
								<Grid container style={{ padding: '0px 30px', alignItems: 'center' }}>
									<Grid item xs={12} md={12} lg={12}>
										<Slider
											ref={slideRefForTimeSlider}
											{...settingsForTime}
											className={classes.testnew + ' ' + classes.timeSlider}
										>
											{timeSlots.map((time, id) => {
												return (
													<Button
														title={time}
														key={'time_' + id}
														id={'time_' + id}
														onClick={() => _handleTimeRange('time_' + id)}
														className={`${classes.timebtn} timeBtnDefault `}
														disabled={checkSlotStatus('time_' + id)}
														variant="outlined"
													>
														{time}
													</Button>
												);
											})}
										</Slider>
									</Grid>
								</Grid>
								<Grid container xs={12} lg={12} md={12} alignItems="center" style={{ marginTop: '15px' }}>
									<Grid item md={7}>
										<Box
											alignContent="flex-start"
											flexDirection="row"
											style={{ paddingLeft: '2%', paddingTop: '1%' }}
											flexGrow={1}
											display="flex"
											flexWrap="wrap"
										>
											<FiberManualRecordIcon style={{ color: currentAvailableTime ? '#1BA257' : '#D71920' }} />
											<Typography
												variant="subtitle2"
												paragraph={true}
												style={{ marginLeft: '25px', paddingTop: '2px' }}
											>
												{currentAvailableTime
													? 'Currently available until ' + currentAvailableTime
													: 'Currently not available'}
											</Typography>
										</Box>
									</Grid>
									<Grid item md={5}>
										<Box alignContent="flex-end" display="flex" flexWrap="wrap" justifyContent="right">
											<Button title="Cancel" variant="outlined" onClick={cancelSlot}>
												Cancel
											</Button>
											&nbsp;&nbsp;&nbsp;
											<Button
												title={`Book desk ${bookDeskbuttonText}`}
												variant="contained"
												className={classes.disableButton}
												disabled={selectedTimeRange === null}
												onClick={bookRoom}
											>
												Book desk {bookDeskbuttonText}
											</Button>
										</Box>
									</Grid>
								</Grid>
							</Paper>
						</Grid>
					)}
				</Grid>

				<Dialog open={esmeDialogOpen} onClose={handleClickClose}>
					<DialogContent className={classes.alignStyle} style={{ maxWidth: '333px' }}>
						<DialogTitle style={{ paddingTop: '21px' }} id="form-dialog-title">
							{zoneSingleRecord ? zoneSingleRecord.ZoneName : ''} selected
						</DialogTitle>
						<DialogContentText style={{ paddingLeft: '24px', paddingRight: '24px', marginBottom: '25px' }}>
							Please confirm your booking of {zoneSingleRecord ? zoneSingleRecord.ZoneName : ''} for{' '}
							{getSelectedTimeRange().start}- {poputmee} on{' '}
							{`${moment(`${selectedDate.date}`).format('ddd')} ${moment(selectedDate.date).format('DD/MM/YYYY')}`}
						</DialogContentText>
						<DialogActions>
							<Button onClick={handleClickClose} title="Cancel" color="primary">
								Cancel
							</Button>
							<Button style={{ paddingRight: '8px' }} onClick={handleClickFinalOpen} title="Confirm" color="primary">
								Confirm
							</Button>
						</DialogActions>
					</DialogContent>
				</Dialog>

				<Dialog open={bookingavailable} onClose={handleAvailableclose}>
					<DialogContent className={classes.alignStyle} style={{ width: '328px', height: '175px' }}>
						<DialogTitle style={{ paddingTop: '21px' }} id="form-dialog-title">
							Desk not available
						</DialogTitle>
						<DialogContentText style={{ paddingLeft: '24px', paddingRight: '24px', marginBottom: '6px' }}>
							The time slot you have selected for this room is no longer available
						</DialogContentText>
						<DialogActions>
							<Button style={{ paddingRight: '8px' }} onClick={handleAvailableclose} title="OK" color="primary">
								OK
							</Button>
						</DialogActions>
					</DialogContent>
				</Dialog>

				<Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
					<DialogContent className={classes.alignStyle} style={{ width: '328px' }}>
						<DialogTitle style={{ paddingTop: '21px' }} id="form-dialog-title">
							Meeting Subject
						</DialogTitle>

						<DialogContentText style={{ paddingLeft: '24px', paddingRight: '24px', marginBottom: '1px' }}>
							Please enter a short title for your meeting subject.
						</DialogContentText>
						<TextField
							style={{ paddingLeft: '24px', paddingRight: '24px', marginBottom: '6px' }}
							autoFocus
							margin="normal"
							id="name"
							label="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Meeting Subject"
							type="text"
							fullWidth
							onChange={subject}
						/>

						<DialogActions>
							<Button onClick={handleClose} title="Cancel" color="primary">
								Cancel
							</Button>
							<Button style={{ paddingRight: '8px' }} onClick={handleClickFinalOpen} title="Save" color="primary">
								Save
							</Button>
						</DialogActions>
					</DialogContent>
				</Dialog>

				<Dialog open={openFinal} onClose={handleClickfinal}>
					<DialogContent className={classes.alignStyle} style={{ maxWidth: '328px' }}>
						<DialogTitle style={{ paddingTop: '21px' }} id="form-dialog-title">
							{`${zoneSingleRecord && zoneSingleRecord.ZoneName}`} booked
						</DialogTitle>

						<DialogContentText style={{ paddingLeft: '24px', paddingRight: '24px', marginBottom: '6px' }}>
							You can view your booking in 'My Bookings'
						</DialogContentText>
						<DialogActions>
							<Button onClick={handleClickfinal} title="Close" color="primary">
								Close
							</Button>
							<Button style={{ paddingRight: '8px' }} color="primary" title="View booking" onClick={redirection}>
								View booking
							</Button>
						</DialogActions>
					</DialogContent>
				</Dialog>
				<Dialog open={consecutiveTimeDialog} onClose={handleConsecutiveSlots}>
					<DialogContent className={classes.alignStyle} style={{ width: '330px', height: '235px' }}>
						<DialogTitle style={{ paddingTop: '21px' }} id="form-dialog-title">
							Some of the times you selected are already booked
						</DialogTitle>
						<DialogContentText style={{ paddingLeft: '24px', paddingRight: '24px', marginBottom: '10px' }}>
							Please select a meeting duration where all times are available or select another space
						</DialogContentText>
						<DialogActions>
							<Button style={{ paddingRight: '8px' }} title="OK" onClick={handleConsecutiveSlots} color="primary">
								OK
							</Button>
						</DialogActions>
					</DialogContent>
				</Dialog>
			</main>
		</>
	));
});

export default DeskInfo;
